import script from "./AssociationPortalConsultDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./AssociationPortalConsultDemo.vue?vue&type=script&setup=true&lang=js"

import "./AssociationPortalConsultDemo.vue?vue&type=style&index=0&id=7a9ad84c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a9ad84c"]])

export default __exports__